module.exports = __webpack_public_path__ + "static/media/collage-flowers.720665cd.png";